var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator"; /* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getLowestPremiumInfo, getWishList } from "../corporate-site/api/wishList";
var initialState = { productList: [], wishList: { list: [], loading: false }, wishListPopup: { message: "", isShowing: false }, productPremiumInfo: { list: [], loading: false }, quoteInfo: { sex: "0", age: 18, smoke: "N", productCodeList: [] }, resendCaptcha: "", resendEmail: "" };
export var setResendEmail = createAction("site/setResendEmail");
export var setResendCaptcha = createAction("site/setResendCaptcha");
export var setProductList = createAction("site/setProductList");
export var setPersonalInfo = createAction("site/setPersonalInfo");
export var resetPersonalInfo = createAction("site/resetPersonalInfo");
export var fetchWishListPopup = createAction("site/fetchWishListPopup");
export var fetchWishList = createAsyncThunk("site/fetchWishList", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { var res; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return getWishList({ type: "view" });
        case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })));
export var fetchLowestPremiumInfo = createAsyncThunk("site/fetchLowestPremiumInfo", /*#__PURE__*/ function () { var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(_, _ref2) { var getState, _ref4, site, res; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            getState = _ref2.getState;
            _ref4 = getState(), site = _ref4.site;
            _context2.next = 4;
            return getLowestPremiumInfo(Object.assign({}, site.quoteInfo, { age: "" + site.quoteInfo.age }));
        case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);
        case 6:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return function (_x, _x2) { return _ref3.apply(this, arguments); }; }());
export var siteSlice = createSlice({ name: "site", initialState: initialState, reducers: {}, extraReducers: function extraReducers(builder) {
        builder.addCase(setProductList, function (state, action) {
            var _action$payload;
            var payloadCopy = JSON.parse(JSON.stringify(action.payload)); // make a copy because action.payload is immutable
            state.productList = payloadCopy.map(function (productList) {
                productList.product_id.map(function (product_id) {
                    var _product_id$page$comp, _product_id$page$comp2; // get the quoteNow url from components[__typename: "ContentfulStickyMenuComponent"]
                    product_id.quoteNowUrl = (_product_id$page$comp = product_id.page.components) === null || _product_id$page$comp === void 0 ? void 0 : _product_id$page$comp.find(function (component) { return component.__typename === "ContentfulStickyMenuComponent"; }).url;
                    product_id.urlTitle = (_product_id$page$comp2 = product_id.page.components) === null || _product_id$page$comp2 === void 0 ? void 0 : _product_id$page$comp2.find(function (component) { return component.__typename === "ContentfulStickyMenuComponent"; }).urlTitle;
                    product_id.page.components = null; // remove components
                    return product_id;
                });
                return productList;
            });
            state.quoteInfo.productCodeList = [].concat.apply([], __spreadArray([], __read(((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.map(function (cat) { var _cat$product_id; return cat === null || cat === void 0 ? void 0 : (_cat$product_id = cat.product_id) === null || _cat$product_id === void 0 ? void 0 : _cat$product_id.map(function (prod) { var _prod$productCode; return { productCode: (_prod$productCode = prod.productCode) !== null && _prod$productCode !== void 0 ? _prod$productCode : "" }; }); }))), false));
        });
        builder.addCase(setResendEmail, function (state, action) { state.resendEmail = action.payload; });
        builder.addCase(setResendCaptcha, function (state, action) { state.resendCaptcha = action.payload; });
        builder.addCase(setPersonalInfo, function (state, action) { localStorage.setItem("personalInfo", JSON.stringify(action.payload)); state.quoteInfo = Object.assign({}, state.quoteInfo, action.payload); });
        builder.addCase(resetPersonalInfo, function (state) { var defaultPersonalInfo = { sex: "0", height: "181", weight: "75", age: 18, smoke: "N" }; localStorage.setItem("personalInfo", JSON.stringify(defaultPersonalInfo)); state.quoteInfo = Object.assign({}, state.quoteInfo, defaultPersonalInfo); });
        builder.addCase(fetchWishListPopup, function (state, action) { state.wishListPopup = Object.assign({}, state.wishListPopup, action.payload); });
        builder.addCase(fetchWishList.fulfilled, function (state, payload) { state.wishList = Object.assign({}, payload.payload, { loading: false }); });
        builder.addCase(fetchWishList.rejected, function (state) { state.wishList.loading = false; });
        builder.addCase(fetchWishList.pending, function (state) { state.wishList.loading = true; });
        builder.addCase(fetchLowestPremiumInfo.fulfilled, function (state, payload) { state.productPremiumInfo = { list: __spreadArray([], __read(payload.payload), false), loading: false }; });
        builder.addCase(fetchLowestPremiumInfo.rejected, function (state) { state.productPremiumInfo.loading = false; });
        builder.addCase(fetchLowestPremiumInfo.pending, function (state) { state.productPremiumInfo.loading = true; });
    } });
